import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useAuthorizeBlockedSlot = (handleClose?: () => void) => {
  const trpcContext = trpc.useUtils();

  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();

  const {
    mutateAsync: authorizeBlockedSlot,
    isLoading: authorizeBlockedSlotIsLoading,
  } = trpc.authorizeBlockedSlot.useMutation({
    onSuccess: async () => {
      trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();

      showSuccess(
        t('common.notification.success.message', {
          action: 'authorized',
          entity: 'blocked slot',
        })
      );
      return handleClose && handleClose();
    },
    onError: async () => {
      showError(
        t('common.notification.error.message', {
          action: 'authorize',
          entity: 'blocked slot',
        })
      );
    },
  });

  return { authorizeBlockedSlot, authorizeBlockedSlotIsLoading };
};
